var render = function render(){var _vm=this,_c=_vm._self._c;return _c('embed',{attrs:{"src":this.src,"type":"application/pdf","width":"100%","height":"95%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }